import { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { Input, Progress, ProgressProps } from "antd";
import { SearchOutlined } from "@ant-design/icons";

import SimCardTrafficApi from "../../../api/SimCardTrafficApi";
import { SimCardTrafficPoolManagementWrapper, FilterItem, FilterItemLabel, ToolBarRightWrapper, ToolBarWrapper, PoolCard, PoolsWrapper, PoolCardTitle, SimCardPoolIcon, PoolCardTitleText, PoolInfoGroup, PoolInfoGroupTitle, PoolCardInfoItem, PoolCardInfoItemLabel, PoolCardInfoItemValue, TrafficUsageText} from "./SimCardTrafficPoolManagement.styled";
import MultiSegmentProgress from "../../../components/ui-components/multi-segment-progress/MultiSegmentProgress";
import SimCardTrafficPoolDetails from "./components/sim-card-traffic-pool-details/SimCardTrafficPoolDetails";

interface SimCardTrafficManagementProps {

}

const SimCardTrafficPoolManagement: React.FC<SimCardTrafficManagementProps> = (props) => {
    let simCardTrafficApi = new SimCardTrafficApi();
    let navigate = useNavigate();

    let [simCardTrafficPoolViews, setSimCardTrafficPoolViews] = useState([]);
    let [loading, setLoading] = useState(true);
    let [search, setSearch] = useState("");

    let loadSimCardTrafficPoolViews = async () => {
        setLoading(true);
        let response = await simCardTrafficApi.getLatestSimCardTrafficPools();
        let simCardTrafficPoolViews = response.data.data;
        setSimCardTrafficPoolViews(simCardTrafficPoolViews);
        setLoading(false);
    };

    let getUsagePercent = (used: number, total: number) => {
        if (!total || total === 0) return 0;
        return ((used / total) * 100).toFixed(1);
    };

    useEffect(() => {
        loadSimCardTrafficPoolViews();
    }, []);

    // render
    let getPoolUsedPercent = (poolView)=> {
        if (poolView.total <= 0) {
            return 0;
        }
        return Number(poolView.used) / Number(poolView.total) * 100;
    };

    let conicColors: ProgressProps['strokeColor'] = {
        '0%': 'rgba(22, 120, 255, 0.5)',
        '20%': 'rgba(22, 120, 255, 0.8)',
        '100%': 'rgba(200, 0, 0, 0.95)',
    };
    
    return (
        <SimCardTrafficPoolManagementWrapper>
            <ToolBarWrapper>
                <ToolBarRightWrapper>
                    <FilterItem>
                        <Input
                            placeholder="请输入关键字"
                            suffix={<SearchOutlined />}
                            size="middle"
                            value={search}
                        />
                    </FilterItem>
                </ToolBarRightWrapper>
            </ToolBarWrapper>
            <PoolsWrapper>
            {
                simCardTrafficPoolViews.map((poolView) => {
                    return <PoolCard>
                        <PoolCardTitle>
                            <SimCardPoolIcon className="iconfont icon-network-traffic"></SimCardPoolIcon>
                            <PoolCardTitleText onClick={()=> navigate('./sim-card/' + poolView.id)}>{poolView.carrier.toUpperCase()}-{poolView.specification}</PoolCardTitleText>
                        </PoolCardTitle>
                        <PoolInfoGroup>
                            <PoolInfoGroupTitle>流量使用情况</PoolInfoGroupTitle>
                            <Progress
                                status="active"
                                percentPosition={{ align: 'end', type: 'inner' }}
                                size={['100%', 20]}
                                showInfo={true}
                                strokeColor={conicColors}
                                percent={getPoolUsedPercent(poolView)} 
                                format={(percent, successPercent)=> {
                                    return <TrafficUsageText>{getPoolUsedPercent(poolView).toFixed(1)}%</TrafficUsageText>;
                                }}
                            />
                            <PoolCardInfoItem style={{marginTop: '5px'}}>
                                <PoolCardInfoItemLabel>已使用</PoolCardInfoItemLabel>
                                <PoolCardInfoItemValue>{poolView.used.toFixed(1)} MB</PoolCardInfoItemValue>
                            </PoolCardInfoItem>
                            <PoolCardInfoItem>
                                <PoolCardInfoItemLabel>总流量</PoolCardInfoItemLabel>
                                <PoolCardInfoItemValue>{poolView.total.toFixed(0)} MB</PoolCardInfoItemValue>
                            </PoolCardInfoItem>
                        </PoolInfoGroup>
                        <PoolInfoGroup>
                            <PoolInfoGroupTitle>卡片状态</PoolInfoGroupTitle>
                            <MultiSegmentProgress
                                style={{height: '20px', borderRadius: '10px'}}
                                segments={[
                                    {
                                        value: poolView.activation,
                                        color: '#52c41a',
                                    },
                                    {
                                        value: poolView.deactivation,
                                        color: '#f5222d',
                                    },
                                    {
                                        value: poolView.inventory,
                                        color: '#faad14',
                                    },
                                    {
                                        value: poolView.testing,
                                        color: '#0367FC',
                                    },
                                    {
                                        value: poolView.retired,
                                        color: '#808080',
                                    }
                                ]}
                             />
                            <PoolCardInfoItem style={{marginTop: '5px'}}>
                                <PoolCardInfoItemLabel>已激活</PoolCardInfoItemLabel>
                                <PoolCardInfoItemValue>{poolView.activation}</PoolCardInfoItemValue>
                            </PoolCardInfoItem>
                            <PoolCardInfoItem>
                                <PoolCardInfoItemLabel>已停卡</PoolCardInfoItemLabel>
                                <PoolCardInfoItemValue>{poolView.deactivation}</PoolCardInfoItemValue>
                            </PoolCardInfoItem>
                            <PoolCardInfoItem>
                                <PoolCardInfoItemLabel>库存中</PoolCardInfoItemLabel>
                                <PoolCardInfoItemValue>{poolView.inventory}</PoolCardInfoItemValue>
                            </PoolCardInfoItem>
                            <PoolCardInfoItem>
                                <PoolCardInfoItemLabel>测试中</PoolCardInfoItemLabel>
                                <PoolCardInfoItemValue>{poolView.testing}</PoolCardInfoItemValue>
                            </PoolCardInfoItem>
                            <PoolCardInfoItem>
                                <PoolCardInfoItemLabel>已销卡</PoolCardInfoItemLabel>
                                <PoolCardInfoItemValue>{poolView.retired}</PoolCardInfoItemValue>
                            </PoolCardInfoItem>
                        </PoolInfoGroup>
                    </PoolCard>
                })
            }
            </PoolsWrapper>

            <Routes>
                <Route path="sim-card/:poolId" element={<SimCardTrafficPoolDetails />} />
            </Routes>
        </SimCardTrafficPoolManagementWrapper>
    );
}

export default SimCardTrafficPoolManagement;